export default "__VITE_ASSET__wOaEIeiP__"